import React, { useState, useContext } from 'react';
import api from './api';
import { ThemeContext } from './ThemeContext';
import { useNavigate, Link } from 'react-router-dom';

export default function Signup() {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const { theme, toggleTheme } = useContext(ThemeContext);
  const navigate = useNavigate();
  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await api.post('/api/signup', { username, password });
      navigate('/login');
    } catch (err) {
      setError(err.response?.data?.message || 'Signup failed');
    }
  };

  return (
    <div className="container mt-5">
      {/* Theme Toggle Button */}
      <button 
        className={`btn ${theme === 'dark' ? 'btn-outline-light' : 'btn-outline-dark'} position-fixed`}
        style={{ top: '20px', right: '20px', zIndex: 1050 }}
        onClick={toggleTheme}
        title={`Switch to ${theme === 'dark' ? 'light' : 'dark'} mode`}
      >
        <i className={`bi bi-${theme === 'dark' ? 'sun' : 'moon'}`}></i>
      </button>
      
      <div className="row justify-content-center">
        <div className="col-md-6 col-lg-4">
          <img src="/logo192.png" alt="Kuppi Site Logo" className="my-2 d-block mx-auto" style={{ width: '150px', height: '130px' }} />
          <div className="card shadow-lg border-0 rounded-lg" style={{ animation: 'fadeIn 0.6s ease-in-out' }}>
            <div className="card-header bg-success text-white text-center py-3">
              <h3 className="my-2">Kuppi Site</h3>
              <h5 className="mb-0">Create Account</h5>
            </div>
            <div className="card-body p-4">
              <form onSubmit={handleSubmit}>
                <div className="mb-3">
                  <label htmlFor="username" className="form-label">Username</label>
                  <div className="input-group">
                    <span className="input-group-text"><i className="bi bi-person-plus-fill"></i></span>
                    <input
                      type="text"
                      id="username"
                      className="form-control"
                      placeholder="Choose a username"
                      value={username}
                      onChange={e => setUsername(e.target.value)}
                      required
                    />
                  </div>
                </div>
                <div className="mb-4">
                  <label htmlFor="password" className="form-label">Password</label>
                  <div className="input-group">
                    <span className="input-group-text"><i className="bi bi-shield-lock-fill"></i></span>
                    <input
                      type="password"
                      id="password"
                      className="form-control"
                      placeholder="Choose a password"
                      value={password}
                      onChange={e => setPassword(e.target.value)}
                      required
                    />
                  </div>
                </div>
                {error && <div className="alert alert-danger py-2" role="alert">{error}</div>}
                <button type="submit" className="btn btn-success w-100 py-2 mb-3">
                  Sign Up
                </button>
              </form>
            </div>
            <div className="card-footer text-center py-3 bg-light">
              <p className="mb-0">
                Already have an account?{' '}
                <Link to="/login" className="text-decoration-none fw-bold">
                  Login
                </Link>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
